/* Come si legge la salute di una linea SIP nel cruscotto 456.

   Dalla mattinata del 30/09/2026, quando una linea accesa ma muta ha fatto fallire dieci
   verifiche di fila: quello che serve a colpo d'occhio e' distinguere la linea che non
   funziona da quella che semplicemente non e' stata usata. */

export const COLORI = {
  buona: '#22c55e',
  incerta: '#f59e0b',
  critica: '#ef4444',
  nessun_dato: 'rgba(255,255,255,.35)',
};

export const ETICHETTE = {
  buona: 'regolare',
  incerta: 'qualche caduta',
  critica: 'non risponde',
  nessun_dato: 'mai usata',
};

export function colore(stato) {
  return COLORI[stato] || COLORI.nessun_dato;
}

export function etichetta(stato) {
  return ETICHETTE[stato] || ETICHETTE.nessun_dato;
}

/* «oggi 15:47», «ieri 09:12», «28/09» — la data per esteso solo quando serve davvero. */
export function quando(iso, adesso = new Date()) {
  if (!iso) return 'mai';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return 'mai';
  const g = (x) => new Date(x.getFullYear(), x.getMonth(), x.getDate());
  const giorni = Math.round((g(adesso) - g(d)) / 86400000);
  const ora = d.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
  if (giorni === 0) return `oggi ${ora}`;
  if (giorni === 1) return `ieri ${ora}`;
  return d.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit' });
}

/* Il riassunto di una riga: «3 verifiche su 3» / «nessuna verifica». */
export function conteggio(l) {
  const t = Number(l?.tentativi || 0);
  if (!t) return 'nessuna verifica';
  return `${Number(l.riuscite || 0)} verifiche su ${t}`;
}
